/**
 * Created by Administrator on 2017/5/18.
 */
import Vue from 'vue';
import moment from 'moment';

Vue.filter('format', function (value, format) {//{{v.createTime|format('YYYY-MM-DD')}}
  if(!value){ return ""}
  format = format || 'YYYY-MM-DD HH:mm:ss';
  return moment(value).format(format);
});
Vue.filter('formatDate', function (value) {//{{v.createTime|formatDate}}
  if(!value){ return ""}
  let ti=moment(value).format("YYYY-MM-DD");
  if(ti!=="Invalid date"){
      return ti
  }
  else{
    return value
  }
});
Vue.filter('formatTime', function (value) {//{{v.createTime|formatTime}}
  if(!value){ return ""}
  return moment(value).format("HH:mm:ss");
});
Vue.filter('formatDateTime', function (value) {//{{v.createTime|formatDateTime}}
  if(!value){ return ""}
  return moment(value).format("YYYY-MM-DD HH:mm:ss");
});
Vue.filter('forensicsStatus', function (value) {//{{v.forensicsStatus|handle}}
    if (value == 0) {
        return "处理中"
    }
    if (value == 1) {
        return "截取成功"
    }
    if (value == 2) {
        return "截取失败"
    }
    if (value == 3) {
        return "网页异常";
    }
    return "状态未知";
});
Vue.filter('captureStatus', function (value) {
    let result;
    value = value + '';
    switch (value) {
        case '0':
            result = '截屏成功';
            break;
        case '1':
            result = '4xx / 5xx';
            break;
        case '2':
            result = '访问频繁';
            break;
        case '3':
            result = '不可访问地址';
            break;
        case '4':
            result = 'phantomjs异常';
            break;
        case '5':
            result = '访问页面超时';
            break;
        case '6':
            result = '保全异常';
            break;
        case '9':
            result = 'http掉用phantomjs异常';
            break;
        default:
            result = '未知状态';
            break;
    }
    return result;
});
Vue.filter('checkStatus',function (value) {
    let result;
    value = value + '';
    switch (value){
        case '0':
            result = '未核查';
            break;
        case '1':
            result = '已核查';
            break;
        default :
            result = '未知状态';
            break;
    }
    return result;
});
Vue.filter('pkgStatus',function (value) {
    if(value === null){
        value = 0;
    }
    let result;
    value = value + '';
    switch (value){
        case '0':
            result = '生效';
            break;
        case '1':
            result = '失效';
            break;
        default:
            result = '未知';
            break;
    }
    return result;
})
Vue.filter('formatFileSize', function (value) {//{{v.fileSize|formatFileSize}}
    if ((value / 1024) > 1024) {
        return Math.round((value / 1024 / 1024) * Math.pow(10, 2)) / Math.pow(10, 2) + "MB";
    } else {
        return Math.round((value / 1024) * Math.pow(10, 2)) / Math.pow(10, 2) + "KB";
    }
});

Vue.filter('leftPad', function (value, size, str) {//{{ v.num|leftPad(10, '0')}}
    if (value == null || value == undefined) {
        return value;
    }
    var result = "" + value;
    if (size <= result.length) {
        return result;
    }
    var pad = (typeof str === "string" && str.length == 1) ? str : "0";
    for (var idx = result.length; idx < size; idx++) {
        result = pad + result;
    }
    return result;
});

Vue.filter('leftPadZero', function (value, size) {//{{ v.num|leftPadZero(10)}}
    if (value == null || value == undefined) {
        return value;
    }
    var result = "" + value;
    if (size <= result.length) {
        return result;
    }
    for (var idx = result.length; idx < size; idx++) {
        result = "0" + result;
    }
    return result;
});

Vue.filter('money', function (value) {//{{v.createTime|formatTime}}//value单位分
  if(value){
    return "￥" + (value/100).toFixed(2);
  }
  return "￥0";
});


Vue.filter('normalmoney', function (value) {
  if(value){
    return "￥" + (value).toFixed(2);
  }
  return "￥0";
});

Vue.filter('money1', function (value) {//{{v.createTime|formatTime}}//value单位分
  if(value){
    return  (value/100).toFixed(2);
  }
  return "0";
});


Vue.filter('normalmoney1', function (value) {
  if(value){
    return (value).toFixed(2);
  }
  return "0";
});
/**
 * CREATE_PRESERVATION(1, "创建保全"),
 TRANSFER_PRESERVATION(2, "转移保全"),
 //TESTIFY_PAY_EBQ(3, "出证支付_保全中心"),
 //TESTIFY_PAY_EBQ_VERIFICATION(4, "出证支付_保全中心_验证证书")
 REWARD_REDUCE(5, "打赏消耗"),
 ADMIN(6, "管理员操作"),
 EXTEND_EVIDENCE_TIME(7, "延长取证时间"),
 APPLY_SIGN(8, "发起签约"),
FORENSICS_URL_CREATE(11, "URL取证"),
  FORENSICS_EVIDENCE_CREATE(12, "上传证据"),
  FORENSICS_SCREENCAP_CREATE(13, "录屏取证"),
  FORENSICS_SCREENSHOT_CREATE(14, "截屏取证"),
  FORENSICS_BUSI_LOG_CREATE(15, "日志保全"),

  WBQ_PROBE_MONITOR(21, "侵权监控"),

  JZQ_REMINDER_SIGN(31, "催签"),
  JZQ_CONTRACT_NOTICE(32, "合同到期提醒"),
  FACE_AUTH(33, "人脸识别"),
  BANK_AUTH_THREE(34, "银行三要素验证"),
  SIGN_CONTRACT(35, "签署合同"),
  JZQ_INSURANCE(36, "君子签购买保险"),
BANK_FOUR_AUTH(37,"银行卡四要素认证")
 */
Vue.filter('pointConsumerType',function (value) {
  if (value === null) {
    return "";
  }
  switch (value) {
    case '1':
      return;
  }
})




// WEBPACK FOOTER //
// ./src/common/js/common-filter.js